import { ClaimActivity } from './ClaimActivity';
import { JsonDateSerializer } from '../../../_base/time/JsonDateSerializer';

export class ClaimOpenedActivity extends ClaimActivity {
    static fromJson(json: any, jsonDateSerializer: JsonDateSerializer) {
        return new ClaimOpenedActivity(
            json.type,
            json.id,
            jsonDateSerializer.fromIso8601(json.date),
            json.claimId,
            json.actorType,
            json.actorId,
            json.actorName,
        );
    }
}
